module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "id": "chapter3"
    }
  }), _vm._v("Chapter Three")]), _vm._v(" "), _c('h3', {
    staticClass: "h3a"
  }, [_vm._v("The Liberation of the Problem of Origin from Its Naturalistic Distortion: The Phenomenological Problem of Constitution")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "sec8"
    }
  }), _vm._v("§ 8. Psychologism and the Problem of History")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Turning now to Klein’s account of the problem of history in Husserl’s early work, we find him maintaining that in “attacking ‘psychologism,’ Husserl was in fact facing the problem of ‘history’ ” (65). Indeed, Klein maintains “that Husserl in criticizing the attitude of historicism [in ‘Philosophy as Rigorous Science’] puts it on the same level with psychologism. In fact, the former is but an extension and amplification of the latter” (68). Thus:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Any “naturalistic” psychological explanation of human knowledge will inevitably be the history of human development with all its contingencies. For in such an account any “idea” is deduced from earlier experiences out of which that idea “originated.” In this view, the explanation of an idea becomes a kind of historical legend, a piece of anthropology. The "), _c('em', [_vm._v("Logical Investigations")]), _vm._v(" showed irrefutably that logical, mathematical, and scientific propositions could never be fundamentally and necessarily determined by this sort of explanation. (65–66)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For Klein, “Husserl’s radical criticism of psychologism implies anything but a simple opposition between never-changing ‘abstract’ principles and ever-changing ‘empirical’ things” (68). Thus, he holds that Husserl’s exposure of the inability of the psychologistic and historicistic appeals to the “natural time” of empirically conceived experience to account for the origin of the eternity or supertemporality of ideal meanings and significations did not rule out all connection of time to the problem of their origin. Rather, Husserl’s recognition of the “naturalistic distortion” (66) of the account of the origin of ideal meanings in psychologism and historicism was followed by his attempt "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v("to “liberate” the problem of their origin from this distortion by disclosing it in terms of “phenomenological” time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On Klein’s view the fact that the phenomenological descriptions grounding Husserl’s account of the “internal temporality” of phenomenological time “were immediately interpreted as psychological descriptions . . . shows not merely that a great many readers of Husserl were not able to understand his thought, but that there is a definite affinity between psychological and phenomenological research” (69). Klein expresses this affinity in terms of the commonality of the “mental phenomena” with which each is concerned. In support of this he refers (69 n. 11) to Husserl’s "), _c('em', [_vm._v("Formal and Transcendental Logic")]), _vm._v(", where Husserl writes that the mistaking of “psychologically inner experience” for “transcendentally” inner experience “is a falsification that could not become noticeable before the advent of transcendental phenomenology” ("), _c('em', [_vm._v("FTL")]), _vm._v(", 224). And thus: “every mode of intentionality, including every mode of evidence and every mode of the fulfilling of meanings through evidence, can also be encountered and treated psychologically”—and not just transcendentally—“"), _c('em', [_vm._v("in the psychological attitude")]), _vm._v(" toward experience.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite this affinity, however, Klein discerns the following:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The real difference [between psychology and phenomenology, or “more exactly . . . between psychological phenomenology and transcendental phenomenology”] can only be found in the fundamentally different attitude of the thinker toward his objects: on the one hand, the psychologist considers them in “mundane apperception,” taking them as existing elements or parts or qualities of the existing world; on the other hand, the phenomenologist deprives these same objects of their “index of existence.” ("), _c('em', [_vm._v("PHS")]), _vm._v(", 69)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The phenomenological reduction, which deprives the mind ("), _c('em', [_vm._v("das Psychische")]), _vm._v(") of its “index of existence,” of its being understood as a “natural object” existing in “natural time,” considers “the mind as the transcendental subjectivity.” And thereby “transcendental phenomenology, as the universal theory of ‘constitution,’ is primarily concerned with the problems of origin, the problem of true beginnings.” Husserl’s characterization of the latter in “Philosophy as Rigorous Science” as the "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Images",
      "src": "images/pcom.jpg"
    }
  }), _vm._v("ιζ"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/wcom1.jpg"
    }
  }), _vm._v("ματα π"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/alpcom1.jpg"
    }
  }), _vm._v("ντων"), _c('sup', [_c('a', {
    attrs: {
      "id": "pt1en_26"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#pt1en26"
    }
  }, [_vm._v("26")])]), _vm._v(" is noteworthy on Klein’s view because in contrast to the traditional "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/alpcom.jpg"
    }
  }), _vm._v("ρχ"), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Images",
      "src": "images/ncom1.jpg"
    }
  }), _vm._v("—which “in the ‘classical’ sense of the term” denotes the “perfect shape” of things—“the (Empedoclean) term . . . ‘root’ is something out of which things grow until they reach their perfect "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v("shape.” Klein interprets this to mean that the “ ‘radical’"), _c('sup', [_c('a', {
    attrs: {
      "id": "pt1en_27"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#pt1en27"
    }
  }, [_vm._v("27")])]), _vm._v(" aspect of phenomenology is more important to Husserl than its perfection,” and he finds in this “the attitude of a true historian.”")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "sec9"
    }
  }), _vm._v("§ 9. Internal Temporality and the Problem of the Sedimented History of Significance")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For Klein, then, Husserl’s liberation of the problem of origin from the naturalistic distortion of psychologism and historicism was achieved through the phenomenological reduction, which brings about the phenomenologist’s “fundamentally different attitude” over against the “empirical” psychologist’s toward the mind or psyche. The result of this liberation was anything but Husserl’s abandonment of the problem of history. On the contrary, his analysis of the “roots” of the origin of the “"), _c('em', [_vm._v("eidos")]), _vm._v(",” of the “"), _c('em', [_vm._v("a priori")]), _vm._v(" form” of each “significant formation” presupposed by both human knowledge and the misguided empirical attempts of psychologism and historicism to account for such meaning, resulted in the phenomenological problem of uncovering its “history of significance” (67)."), _c('sup', [_c('a', {
    attrs: {
      "id": "pt1en_28"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#pt1en28"
    }
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("According to Klein, Husserl’s awareness of this problem followed “the first step—first in the actual development of Husserl’s thought, and first in any phenomenological analysis”—of “finding the ‘invariables’ within the absolute flow (the ‘internal temporality’) of the mind,” of “determining the ‘invariants’ which remain unchanged by reason of an essential necessity.” Thus Husserl’s “reflection upon this kind of analysis, its implications and significance,” led to the realization that, “[f]ar from being complete in itself, the finding and facing [of] an ‘essence’ requires a further investigation into its intrinsic ‘possibility.’ ” This is the case because the “possibility” of an "), _c('em', [_vm._v("eidos")]), _vm._v(" is not exhausted by the process that initially yields it, that is, the “continuous and arbitrary ‘variation’ of a given ‘example,’ a variation that takes place in the ‘freedom of pure fantasy.’ ” Rather, whatever is discovered “as having a definite significance—an essence, its ‘inflections,’ its essential characteristics, the compresent ‘halo,’ and so forth—has also a ‘backward reference’ to a more original ‘significant formation.’ ” It is precisely this “backward reference” that allows for the uncovering of the history of significance of each significant formation, which “describes the ‘genesis’ of that mental product.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "pt1en_29"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#pt1en29"
    }
  }, [_vm._v("29")])]), _vm._v(" The “historicity”"), _c('sup', [_c('a', {
    attrs: {
      "id": "pt1en_30"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#pt1en30"
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v("at issue in this genesis is characterized by Klein as “a curious kind of ‘history,’ . . . a peculiarity of the mind, whose manner of being is nothing but ‘work’ ("), _c('em', [_vm._v("Leistung")]), _vm._v("), a constructive work, tending toward the formation of ‘units of significance’—an ‘intentionality at work.’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "id": "pt1en26"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#pt1en_26"
    }
  }, [_vm._v("26")]), _vm._v(". Edmund Husserl, “Philosophie als strenge Wissenschaft,” "), _c('em', [_vm._v("Logos")]), _vm._v(" I (1910–11), 289–341, here 340; English translation: “Philosophy as Rigorous Science,” trans. Marcus Brainard, "), _c('em', [_vm._v("New Yearbook for Phenomenology and Phenomenological Philosophy")]), _vm._v(" II (2002), 249–95; henceforth cited as "), _c('em', [_vm._v("PRS")]), _vm._v(" with the original German page reference, which is reproduced in the margins of the English translation.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "pt1en27"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#pt1en_27"
    }
  }, [_vm._v("27")]), _vm._v(". Klein probably has in mind here the Latin etymology of ‘radical’ ("), _c('em', [_vm._v("radic")]), _vm._v("-, "), _c('em', [_vm._v("radix")]), _vm._v(", root); see Husserl’s characterization of phenomenology in “Philosophy as Rigorous Science” as “the method of a radical science” ("), _c('em', [_vm._v("PRS")]), _vm._v(", 340; see Klein, "), _c('em', [_vm._v("PHS")]), _vm._v(", 65).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "pt1en28"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#pt1en_28"
    }
  }, [_vm._v("28")]), _vm._v(". The reference, unattributed by Klein, is to Husserl, "), _c('em', [_vm._v("FTL")]), _vm._v(", 184.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "pt1en29"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#pt1en_29"
    }
  }, [_vm._v("29")]), _vm._v(". The source of this quote, as well as of Klein’s paraphrase here, is Husserl’s "), _c('em', [_vm._v("FTL")]), _vm._v(", 184.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "pt1en30"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#pt1en_30"
    }
  }, [_vm._v("30")]), _vm._v(". Klein does not use this term—‘historicity’ ("), _c('em', [_vm._v("Historizität")]), _vm._v(")—here, though Husserl does. See "), _c('em', [_vm._v("FTL")]), _vm._v(", 184.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5755fa64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter3.vue
// module id = 99
// module chunks = 0